import { isEqual } from "lodash";
import { useRef } from "react";

export function useDeepCompare<T>(value: T) {
    const ref = useRef<T | undefined>(undefined);

    if (!isEqual(ref.current, value)) {
        ref.current = value;
    }

    return ref.current;
}
